var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['container-detail', _vm.getSelectedDEV && 'dev-selected-component'],on:{"contextmenu":function($event){return _vm.selectComponentDEV($event, _vm.schema.model)}}},[(this.schema.items && this.schema.items.length > 0)?_c('i4proTableDetailRecursive',{attrs:{"headers":this.schema.items[0].header,"items":this.schema.items}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }